import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.User;

export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const errorSelector = createSelector(rootSelector, (state) => state.error);
export const dataSelector = createSelector(rootSelector, (state) => state.data);
export const userNamesSelector = createSelector(dataSelector, (data) => data?.data?.userName);
export const isCurrentUserSelector = createSelector(rootSelector, (state) => state?.data?.isCurrentUser);
export const errorTypeSelector = createSelector(rootSelector, (state) => state.errorType);

export default {
  statusSelector,
  errorSelector,
  dataSelector,
  userNamesSelector,
  isCurrentUserSelector,
  errorTypeSelector,
};
